import { FunctionComponent, ReactNode } from 'react';
import { makeAutoObservable } from 'mobx';

export enum NoticeType {
  SUCCESS, ERROR, WARN,
}

export class NoticeStore {
  noticeBody: ReactNode = null;
  noticeComponent: FunctionComponent = null;
  type: NoticeType = NoticeType.SUCCESS;

  constructor() {
    makeAutoObservable(this);
  }

  setNotice = (body: ReactNode, type: NoticeType) => {
    this.noticeBody = body;
    this.noticeComponent = null;
    this.type = type;
  };

  setNoticeType = (component: FunctionComponent, type: NoticeType) => {
    this.noticeBody = null;
    this.noticeComponent = component;
    this.type = type;
  };

  reset = () => {
    this.noticeBody = null;
    this.noticeComponent = null;
  };

  get hasNotice(): boolean {
    return this.noticeBody !== null || this.noticeComponent !== null;
  }
}

export const NoticeStoreInstance = new NoticeStore();
